import ValidationType from '../ValidationType';

class ValidPhoneNumber extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    const errors = [];
    const currentValue = fieldResponse.currentValue || '';

    // Remove a mask if there is one
    const maskRemoved = currentValue.replaceAll(/[\+\(\)\-\s]/g, '');
    if (maskRemoved.length) {
      if (maskRemoved.split('').some(char => isNaN(char))) {
        // Every character must be a number
        errors.push(this._createError(fieldResponse, currentValue));
      }
      if (maskRemoved.length !== 10) {
        // Expect the number to be a valid 10 digits (i.e. not including country code)
        errors.push(this._createError(fieldResponse, currentValue));
      }
    }
    return errors;
  }

  _createError(fieldResponse, value) {
    return this.createValidationError({
      fieldResponse,
      key: 'ERROR_VALID_PHONE_NUMBER',
      values: { value },
      message: `Value '${value}' is not a valid phone number`,
    });
  }
}

export default ValidPhoneNumber;
